import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {ShopTapBoxV2} from "../common/ShopTapBoxV2";
import shopModiBtn3 from "../../../static/image/v2/shop/shopModiBtn3.png";
import shopModiBtn4 from "../../../static/image/v2/shop/shopModiBtn4.png";
import {useShopInfo3} from "../../../static/js/hock/shopHock";
import {openPopup} from "../../../static/js/Common2";
import {ShopInfo3PopupV2} from "./ShopInfo3PopupV2";
import {subNavEvent} from "../../../static/js/service/commonService";
import {formatDay} from "../../../utils/formatUtils";

export default function ShopInfo3V2() {
  let [shopList, setShopList] = useState([]);
  let [shopId, setShopId] = useState();
  let [holidayList, setHolidayList] = useState([]);
  let [shopHolidayList, setShopHolidayList] = useState([]);
  let [shopLegalHolidayList, setShopLegalHolidayList] = useState([]);
  let [status, setStatus] = useState();
  let [pauseStartDate, setPauseStartDate] = useState(null);
  let [pauseEndDate, setPauseEndDate] = useState(null);
  let [approvalTpcd1, setApprovalTpcd1] = useState();
  let [startTimeList, setStartTimeList] = useState([]);
  let [endTimeList, setEndTimeList] = useState([]);
  let [tempClosingStartDate, setTempClosingStartDate] = useState(null);
  let [tempClosingEndDate, setTempClosingEndDate] = useState(null);


  useShopInfo3({
    setHolidayList, setShopHolidayList,
    setShopLegalHolidayList,
    setStatus, setPauseStartDate, setPauseEndDate, setApprovalTpcd1,
    setStartTimeList, setEndTimeList, setTempClosingStartDate, setTempClosingEndDate
  }, shopId)


  useEffect(() => {
    subNavEvent("shopNav", "shop1");
  }, []);

  if(startTimeList.length > 0) {
    timeList(startTimeList, 1);
  }
  if(endTimeList.length > 0) {
    timeList(endTimeList, 2);
  }

  let shopHolidayText = "";
  let legalHolidayText = '';

  if(shopHolidayList.length > 0) {
      // 정렬 추가
    const sorted = [...shopHolidayList].sort((a, b) => {
      if(a.periodTpcd !== b.periodTpcd) return a.periodTpcd - b.periodTpcd;
      return a.dowTpcd - b.dowTpcd;
    });
    
    for(let i = 0; sorted.length > i; i++) {
      let type = "매주";
      let day = "월요일";
      let value = sorted[i];

      if(value.periodTpcd === 3) {
        type = '매달 첫째주'
      } else if(value.periodTpcd === 4) {
        type = '매달 둘째주'
      } else if(value.periodTpcd === 5) {
        type = '매달 셋째주'
      } else if(value.periodTpcd === 6) {
        type = '매달 넷째주'
      } else if(value.periodTpcd === 7) {
        type = '매달 다섯째주'
      }

      if(value.dowTpcd === 2) {
        day = '화요일'
      } else if(value.dowTpcd === 3) {
        day = '수요일'
      } else if(value.dowTpcd === 4) {
        day = '목요일'
      } else if(value.dowTpcd === 5) {
        day = '금요일'
      } else if(value.dowTpcd === 6) {
        day = '토요일'
      } else if(value.dowTpcd === 7) {
        day = '일요일'
      }

      shopHolidayText += type + ' ' + day + ', '
    }
    shopHolidayText = shopHolidayText.slice(0, -2);
  } else {
    shopHolidayText = "연중무휴";
  }

  if(shopLegalHolidayList.length !== 0) {
    legalHolidayText = "모든 공휴일 휴무";
  }

  let stopText = "설정안함";

  if(status === 5) {
    let pauseStartTs = pauseStartDate.substr(11, 5);
    let pauseEndTs = pauseEndDate.substr(11, 5);
    stopText = `${pauseStartTs} ~ ${pauseEndTs}`;
  }

  function timeList(list, number) {
    list.forEach(({id, startTime, endTime, dayOfWeek}) => {
      let day = formatDay(dayOfWeek);
      let startDate = startTime.split(':');
      let hour1 = startDate[0];
      let minutes1 = startDate[1];
      let endDate = endTime.split(':');
      let hour2 = endDate[0];
      let minutes2 = endDate[1];

      let dataA = Number(startTime.replace(/:/g, ''))
      let dataB = Number(endTime.replace(/:/g, ''))

      let p = document.createElement('p')
      if(dataB - dataA < 0) {
        p.innerHTML = `${ day } ${ hour1 }:${ minutes1 } ~ 익일 ${ hour2 }:${ minutes2 }`
      } else {
        p.innerHTML = `${ day } ${ hour1 }:${ minutes1 } ~ ${ hour2 }:${ minutes2 }`
      }

      document.querySelector(`.shopTime${number}List`).appendChild(p);

      let timeInputBox = document.querySelector(`.timeInputBox${number}${dayOfWeek}`);
      timeInputBox.setAttribute("data-id", id);
      timeInputBox.querySelector(".timeCheck").checked = true;
      timeInputBox.querySelector(".hour1").value = hour1;
      timeInputBox.querySelector(".minutes1").value = minutes1;
      timeInputBox.querySelector(".hour2").value = hour2;
      timeInputBox.querySelector(".minutes2").value = minutes2;
    });
  }

  return (
    <main id="ShopInfo3V2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <ShopInfo3PopupV2 shopId={shopId} operTimeList={startTimeList} shopHoliday={shopHolidayList} legalHoliday={holidayList} shopLegalHoliday={shopLegalHolidayList} startDate={tempClosingStartDate} endDate={tempClosingEndDate} status={status} />

      <div className="container">
        <section id="shopSec1" className="containerInner">
          <PageNameV2 title1="상점 관리" title2="상점 정보 관리" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="상점 정보 관리" countText="" count="" unit="" />
          </div>
          <div className="topMenu">
            <div id="shopSelectBox">
              <ShopSelectBoxV2 url="/v2/shopInfo3" setShopId={setShopId} setShopList={setShopList} />
              <ShopTapBoxV2 tap="tap3" shopId={shopId} />
            </div>
          </div>
          <div className="shopInfoBox">
            <table className="shopInfoTable">
              <thead></thead>
              <tbody>
              <tr>
                <th>영업시간</th>
                <td>
                  <div className="flexTd">
                    <div className="shopTime1List"></div>
                    {approvalTpcd1 === 4 &&
                      <button className="ediBtn openBtn" onClick={() => openPopup("shopInfoTime1Popup")}>
                        <img src={ shopModiBtn3 } alt="수정" />
                      </button>
                    }
                  </div>
                </td>
              </tr>
              <tr>
                <th>휴식시간</th>
                <td>
                  <div className="flexTd">
                    <div className="shopTime2List"></div>
                    {approvalTpcd1 === 4 &&
                      <button className="ediBtn openBtn" onClick={() => openPopup("shopInfoTime2Popup")}>
                        <img src={ shopModiBtn3 } alt="수정" />
                      </button>
                    }
                  </div>
                </td>
              </tr>
              <tr>
                <th>휴무일</th>
                <td>
                  <div className="flexTd">
                    <div className="shopHoliday">
                      <div>
                        <span className="shopHolidayText">공휴일</span>
                        {legalHolidayText}
                      </div>
                      <div>
                        <span className="shopHolidayText">정기휴무</span>
                        {shopHolidayText}
                      </div>
                      <p>※앱에 표시되는 용도로 설정 값에 맞춰 상점 상태 변경은 안됩니다.</p>
                    </div>
                    {approvalTpcd1 === 4 &&
                      <button className="ediBtn openBtn" onClick={() => openPopup("shopHolidayPopup")}>
                        <img src={ shopModiBtn3 } alt="수정" />
                      </button>
                    }
                  </div>
                </td>
              </tr>
              <tr>
                <th>임시 휴무</th>
                <td>
                  <div className="flexTd">
                    <div>
                      {tempClosingStartDate !== "2000-01-01" && tempClosingEndDate !== "2000-01-01" &&
                        <p>{tempClosingStartDate} ~ {tempClosingEndDate}</p>
                      }
                    </div>
                    {approvalTpcd1 === 4 &&
                      <button className="ediBtn openBtn" onClick={() => openPopup("shopTempPopup")}>
                        <img src={ shopModiBtn3 } alt="수정" />
                      </button>
                    }
                  </div>
                </td>
              </tr>
              {/* <tr>
                <th>영업일시중지</th>
                <td>
                  <div className="stopBox">
                    <span>{stopText}</span>
                    {approvalTpcd1 === 4 &&
                      <button className="ediBtn openBtn">
                        <img src={ shopModiBtn4 } alt="수정" onClick={() => openPopup("stopChoicePopup")} />
                      </button>
                    }
                  </div>
                </td>
              </tr> */}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </main>
  )
}